import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchDesignationDetail = createAsyncThunk(
  "fetchDesignationDetail",
  async ({ id }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };

    const response = await axiosHttp.get(
      `designation/detail/${id}`,
      config
    );
    
    return response.data.data;
  }
);

const designationDetailSlice = createSlice({
  name: "designationDetail",
  initialState: {
    isLoading: false,
    data: null,
    error: null,
  },
 
  reducers: {
    resetStateDesignationDetail: (state) => {
      state.isLoading = false;
      state.error = null;
      state.data = null;
    }
  },

  extraReducers: (builder) => {
    builder.addCase(fetchDesignationDetail.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(fetchDesignationDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;

    });
    builder.addCase(fetchDesignationDetail.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export const { resetStateDesignationDetail } = designationDetailSlice.actions;
export default designationDetailSlice.reducer;